import React ,{ PureComponent } from "react";
import { Link } from "react-router-dom";
import * as myConstClass from '../../constant.js';
import { Button } from "reactstrap";
import * as Icon from "react-feather";
import $ from 'jquery';
class Page406 extends PureComponent {
  constructor(props) {
    super(props);
    this.routeChange = this.routeChange.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  routeChange() {
    this.props.history.push('/');
  }

  handleLogout() {
    localStorage.clear();                          // Clear all localStorage items
    window.location.href = '/';                  // Redirect to login page
  }

componentDidMount(){
  $('.main').css('background-image', 'none');
        $('.main').css('background-size', 'none');
 // localStorage.clear();
  
}

render() {

  return (
  
    <div className="text-center">
    {/* <h1 className="display-1 font-weight-bold">404</h1>
     <p className="h1">Page not found.</p> */}
    <p className="h2 font-weight-normal mt-3 mb-4">
     Connecting............
    </p> 
     <Link to={'/'+myConstClass.TENANT_PAGE_PATH+"guests/listing"}>
      <Button color="primary" size="lg">
       Return to Guest Listing and Refresh It
      </Button>
    </Link>
     {/* Logout Button */}
            <Button
              color="info"
              size="lg"
              onClick={this.handleLogout}
            >
              <Icon.LogOut size={18} className="mr-1" />
              Logout
            </Button>
  </div>
  )
}
}


// const Page404 = () => (

//   <div className="text-center">
//     {/* <h1 className="display-1 font-weight-bold">404</h1>
//      <p className="h1">Page not found.</p> */}
//     <p className="h2 font-weight-normal mt-3 mb-4">
//      Connecting............
//     </p> 
//      <Link to={'/'+myConstClass.TENANT_PAGE_PATH+"dashboard"}>
//       <Button color="primary" size="lg">
//        Return to Dashboard
//       </Button>
//     </Link>
//   </div>
// );

export default Page406;


